import { render, staticRenderFns } from "./ChineseReport.vue?vue&type=template&id=6364a0cc&scoped=true"
import script from "./ChineseReport.vue?vue&type=script&lang=js"
export * from "./ChineseReport.vue?vue&type=script&lang=js"
import style0 from "./ChineseReport.vue?vue&type=style&index=0&id=6364a0cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6364a0cc",
  null
  
)

export default component.exports